module.exports = __webpack_public_path__ + "img/pic3-0.f429bd3c.png";